import React, { useEffect } from "react";
import FAQSection from "../components/FAQSection";
import { Link } from "react-router-dom";
import ServicesSection from "../components/ServicesSection";
import { Helmet } from "react-helmet";
const LeadsGeneration = () => {
    useEffect(() => {
        document.title =
            "MM Auto Tech | How to Increase Sales in a Garage Business";

        const metaDescription = document.querySelector(
            "meta[name='description']"
        );
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Discover effective strategies to increase sales in a garage business with MM Auto Tech. Streamline your operations, attract new customers, and boost revenue."
            );
        } else {
            const meta = document.createElement("meta");
            meta.name = "description";
            meta.content =
                "Discover effective strategies to increase sales in a garage business with MM Auto Tech. Streamline your operations, attract new customers, and boost revenue.";
            document.head.appendChild(meta);
        }
    }, []);

    return (
        <><Helmet>
  <title>Leads Generation Services | MM AutoTech</title>
  <meta
    name="description"
    content="Generate high-quality leads for your UK garage with MM AutoTech’s targeted marketing and funnel solutions."
  />
  <link rel="canonical" href="https://mmautotech.com/services/leads-generation" />
</Helmet>
<div className="max-w-7xl mx-auto space-y-24">
                {/* Hero Section */}
                <section className="flex flex-col lg:flex-row items-stretch bg-blue-900 text-white">
                    {/* Left Image (Foreground) */}
                    <div
                        className="lg:w-1/2 h-64 lg:h-auto relative overflow-hidden"
                        style={{ clipPath: "polygon(0 0, 85% 0, 100% 100%, 0% 100%)" }} // inverse clip for left
                    >
                        <img
                            src="https://s2wmedia.com/hubfs/Imported_Blog_Media/64b684bbad558e5a92e53e3f_Picture1dgsd-4.jpg"
                            alt="Digital Marketing"
                            className="w-full h-72 md:h-full object-cover" />
                    </div>

                    {/* Right Content */}
                    <div className="lg:w-1/2 p-8 flex flex-col justify-center">
                        <h2 className="text-4xl font-bold mb-6 leading-snug">MM AutoTech – Leads You Can Trust</h2>
                        <p className="text-lg text-gray-200 mb-6">
                            We specialize in connecting dealerships with ready-to-buy
                            customers through data-driven strategies. Our trusted process
                            ensures better conversions and long-term success for your
                            garage business.
                        </p>
                        <Link
                            to="/book-appointment"
                            className="inline-flex items-center justify-center text-sm font-semibold tracking-widest text-white border border-white px-6 py-2 rounded hover:bg-yellow-400 hover:border-yellow-400 transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-900/30"
                            aria-label="Book an appointment"
                        >
                            Book an Appointment
                        </Link>
                    </div>
                </section>

                {/* Features Section */}
                <section className="py-16 px-6 md:px-16 bg-white text-gray-900 text-center">
                    <p className="text-sm md:text-base text-gray-600 mb-12 max-w-2xl mx-auto">
                        We connect automotive garages and workshops with real customers actively looking for repair, maintenance, and MOT services.
                        Our exclusive lead generation system ensures you get quality inquiries that convert into loyal clients.
                    </p>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
                        {[
                            {
                                icon: "https://img.icons8.com/ios-filled/50/ffffff/clock.png",
                                label: "REAL-TIME LEADS",
                            },
                            {
                                icon: "https://img.icons8.com/ios-filled/50/ffffff/user.png",
                                label: "GARAGE-EXCLUSIVE",
                            },
                            {
                                icon: "https://img.icons8.com/ios-filled/50/ffffff/medal.png",
                                label: "QUALIFIED CUSTOMERS",
                            },
                            {
                                icon: "https://img.icons8.com/ios-filled/50/ffffff/filter.png",
                                label: "HIGH CONVERSION",
                            },
                        ].map((item, i) => (
                            <div key={i} className="flex flex-col items-center">
                                <div className="bg-blue-600 p-4 rounded-md flex items-center justify-center">
                                    <img src={item.icon} alt={item.label} className="w-8 h-8" />
                                </div>
                                <p className="mt-2 text-sm font-semibold text-gray-800 uppercase text-center">
                                    {item.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Info Section */}
                <section
                    className="py-20 px-6 md:px-16 bg-cover bg-center bg-no-repeat"
                    style={{
                        backgroundImage: "url('https://s2wmedia.com/hs-fs/hubfs/Imported_Blog_Media/64b688edb8e9da28bd0bc6a5_AdobeStock_605419590_MI-Jul-21-2025-12-12-59-8841-PM.png?width=2400&height=1500&name=64b688edb8e9da28bd0bc6a5_AdobeStock_605419590_MI-Jul-21-2025-12-12-59-8841-PM.png')",
                    }}
                >
                    <div className="max-w-3xl bg-white/90 p-8 rounded-md shadow-md">
                        <h3 className="text-sm font-bold text-gray-900 uppercase mb-1 tracking-wider border-b-2 border-red-600 inline-block pb-1">
                            Who We Are
                        </h3>
                        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight mb-6">
                            Driving Growth for Garages & Workshops
                        </h2>
                        <p className="text-sm md:text-base text-gray-700 mb-8">
                            At <strong>MM AutoTech Leads</strong>, we specialize in helping garages and auto workshops grow
                            by providing high-quality, exclusive customer leads. Whether you need more bookings for MOTs,
                            repairs, servicing, or tire replacements, our system ensures a steady stream of inquiries so
                            you can focus on what you do best—servicing vehicles.
                        </p>
                        <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-md transition">
                            Discover More
                        </button>
                    </div>
                </section>

                {/* What We Do */}
                <section className="pt-16 pb-0 px-6 md:px-16 bg-gray-50 text-center">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                        What We Do
                    </h2>
                    <h3 className="text-xl md:text-2xl font-extrabold text-gray-900 mb-10 uppercase tracking-wide relative inline-block">
                        Lead Generation Designed for Automotive Businesses
                        <span className="block w-24 h-1 bg-red-600 mx-auto mt-2"></span>
                    </h3>
                    <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
                        <div className="bg-white shadow-md rounded-md p-6 text-left">
                            <h4 className="text-lg font-bold text-gray-900 mb-2">
                                Real-Time Customer Inquiries
                            </h4>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                Receive fresh leads the moment a customer requests garage services in your area—so you can respond first and secure the booking.
                            </p>
                        </div>
                        <div className="bg-white shadow-md rounded-md p-6 text-left">
                            <h4 className="text-lg font-bold text-gray-900 mb-2">
                                Exclusive, High-Quality Leads
                            </h4>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                We never resell the same lead to multiple garages. Every inquiry is matched exclusively to your workshop, ensuring better ROI.
                            </p>
                        </div>
                        <div className="bg-white shadow-md rounded-md p-6 text-left md:col-span-2">
                            <h4 className="text-lg font-bold text-gray-900 mb-2">
                                Localized Lead Generation
                            </h4>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                We target customers within your service area through multi-channel marketing campaigns—driving genuine, local demand for your garage.
                            </p>
                        </div>
                    </div>
                </section>

                <ServicesSection />

                {/* Testimonials */}
                <section className="py-16 px-4 md:px-10 bg-white">
                    <div className="max-w-6xl mx-auto">
                        <h2 className="text-3xl font-bold text-blue-900 mb-2">
                            What Our Customers Say
                        </h2>
                        <div className="w-24 border-b-4 border-yellow-400 mb-4"></div>
                        <p className="text-gray-600 mb-10">
                            See what customers are saying about MM Auto Tech Sales.
                        </p>
                        <div className="grid md:grid-cols-2 gap-6">
                            {/* Testimonial 1 */}
                            <div className="bg-blue-50 p-6 rounded-lg shadow-sm border-b-4 border-yellow-400">
                                <p className="text-blue-700 mb-4">
                                    <span className="text-2xl font-serif text-gray-400">“</span>
                                    The level of detail and efficiency at MM AutoTech boosted
                                    our conversions in no time!
                                </p>
                                <div className="flex items-center mt-4">
                                    <img
                                        src="https://pbs.twimg.com/profile_images/730044763672608768/fwucZjTX_400x400.jpg"
                                        alt="Howard Chavez"
                                        className="w-10 h-10 rounded-full mr-3" />
                                    <span className="text-sm font-medium text-gray-800">
                                        Howard Chavez
                                    </span>
                                </div>
                            </div>
                            {/* Testimonial 2 */}
                            <div className="bg-blue-50 p-6 rounded-lg shadow-sm border-b-4 border-yellow-400">
                                <p className="text-blue-700 mb-4">
                                    <span className="text-2xl font-serif text-gray-400">“</span>
                                    MM AutoTech’s lead quality is top-notch. Conversion rates
                                    soared!
                                </p>
                                <div className="flex items-center mt-4">
                                    <img
                                        src="https://images.unsplash.com/photo-1502764613149-7f1d229e230f?ixlib=rb-4.0.3&auto=format&fit=crop&w=80&q=80"
                                        alt="Lucas Elliot"
                                        className="w-10 h-10 rounded-full mr-3" />
                                    <span className="text-sm font-medium text-gray-800">
                                        Lucas Elliot
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <FAQSection
                    data={[
                        {
                            q: "What type of leads do you provide?",
                            a: "We provide exclusive, high-quality leads for garage and workshop services including MOTs, car servicing, brake repairs, tire replacements, diagnostics, and bodywork."
                        },
                        {
                            q: "Are the leads shared with multiple garages?",
                            a: "No. Every lead is exclusive to your business only. This ensures you get the best chance of converting inquiries into paying customers."
                        },
                        {
                            q: "How do you generate leads?",
                            a: "We use multi-channel digital marketing campaigns including Google Ads, social media, and automotive platforms to target customers in your local area actively searching for garage services."
                        },
                        {
                            q: "Do I need to sign a long-term contract?",
                            a: "No long-term contracts are required. You can start, pause, or stop whenever you want. We believe in flexibility and results-based partnerships."
                        },
                        {
                            q: "How quickly will I start receiving leads?",
                            a: "Leads are delivered in real-time as soon as customers request garage services. Most garages start seeing leads within 24-48 hours of joining."
                        },
                        {
                            q: "How are the leads delivered?",
                            a: "Leads are sent instantly via email, SMS, or integrated into your CRM system so your team can respond right away."
                        }
                    ]} />

                {/* CTA: Business Support Focused Conversion Block */}
                <section className="py-16 bg-[#0f172a] text-white px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden">
                    <div className="max-w-3xl mx-auto">
                        <p className="uppercase tracking-wider text-sm mb-2 font-semibold text-gray-300">
                            Start Growing Your Garage Business
                        </p>
                        <p className="text-3xl sm:text-4xl font-bold text-white mb-2">
                            Get Exclusive Customer Leads Today
                        </p>
                        <div className="w-12 h-1 bg-yellow-400 mx-auto mb-6"></div>
                        <p className="uppercase text-sm font-medium text-gray-300 mb-6 tracking-widest">
                            Book a Free Demo Call With Our Team
                        </p>
                        <button className="inline-flex items-center gap-2 bg-[#1f2e9f] hover:bg-blue-700 text-white px-6 py-3 rounded-md font-bold shadow-md">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M8 7V3M16 7V3M3 11h18M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            Book a Demo
                        </button>
                    </div>
                </section>
            </div></>
    );
};

export default LeadsGeneration;
